export default __webpack_public_path__ + "static/media/Snd_N_Starts.00eb1a44.mp3";